import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { trackEvent } from 'analytics/trackFunctions'
import { URL_LANDING, ZENDESK_URL } from 'config'

// Custom components
import { NewCardButton } from 'components/CardButtons'
import PageWrapper from 'components/PageWrapper'

const BUTTONS = [
  {
    title: 'Términos y condiciones',
    id: 'terms',
    url: `${ZENDESK_URL}/categories/18071922145435-T%C3%A9rminos-y-condiciones`,
    event: 'bille_legales_TyC'
  },
  {
    title: 'Políticas de privacidad',
    id: 'privacy',
    url: `${URL_LANDING}/politicas-y-privacidad`,
    event: 'bille_legales_politicas'
  },
  {
    title: 'Contratos de adhesión (Ley 24.240)',
    id: 'adhesion',
    url: 'contratos-de-adhesion',
    event: 'bille_legales_contratos'
  },
  {
    title: 'Tarifas y cargos',
    id: 'fees',
    url: `${ZENDESK_URL}/articles/26889445930011-Tasas-cargos-y-comisiones`,
    event: 'bille_legales_tarifas'
  }
]

const Legals = () => {
  const navigate = useNavigate()

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_legales' })
  }, [])

  return (
    <PageWrapper
      viewSelected='/centro-de-ayuda'
      className='!px-0 md:px-4'
      title='Legales'
      noTabBar
    >
      <section className='px-4 mt-4 text-black md:flex md:max-w-564 md:flex-col mb-20 md:mb-5 mx-auto'>
        <div className='space-y-4'>
          {BUTTONS.map((item) => (
            <NewCardButton
              key={item.id}
              onClick={() => {
                trackEvent({ eventName: item.event })
                item.id === 'adhesion'
                  ? navigate(item.url)
                  : window.open(item.url, '_blank')
              }}
            >
              <span className='text-purple-900 text-xs font-bold'>
                {item.title}
              </span>
            </NewCardButton>
          ))}
        </div>
      </section>
    </PageWrapper>
  )
}

export default Legals
